import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import { Separator } from '@/components/ui/Separator';
import { BuildVersion } from '@/utils/meta.function';

interface SystemInfoDialogProps {
  open: boolean;
  serverVersion: BuildVersion | undefined;
  clientVersion: BuildVersion;
  onToggleOpen: () => void;
}

export function SystemInfoDialog({
  open,
  serverVersion,
  clientVersion,
  onToggleOpen,
}: SystemInfoDialogProps) {
  const handleToggleOpenState = () => {
    onToggleOpen();
  };

  return (
    <Dialog open={open} onOpenChange={handleToggleOpenState}>
      <DialogContent className="flex flex-col">
        <DialogHeader>
          <DialogTitle>System</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <div className="text-muted-foreground flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <div className="text-lg font-semibold">Server</div>
            <div className="gap-1 px-2">
              <div className="grid grid-cols-3">
                <span className="col-span-1">Version: </span>
                <span className="col-span-2">{serverVersion?.tag}</span>
              </div>
              <div className="grid grid-cols-3">
                <span className="col-span-1">Hash: </span>
                <span className="col-span-2">{serverVersion?.hash}</span>
              </div>
              <div className="grid grid-cols-3">
                <span className="col-span-1">Branch: </span>
                <span className="col-span-2">{serverVersion?.branch}</span>
              </div>
              <div className="grid grid-cols-3">
                <span className="col-span-1">Build Time: </span>
                <span className="col-span-2">{serverVersion?.time}</span>
              </div>
            </div>
          </div>
          <Separator />
          <div className="flex flex-col gap-1">
            <div className="text-lg font-semibold">Client</div>
            <div className="gap-1 px-2">
              <div className="grid grid-cols-3">
                <span className="col-span-1">Version: </span>
                <span className="col-span-2">{clientVersion?.tag}</span>
              </div>
              <div className="grid grid-cols-3">
                <span className="col-span-1">Hash: </span>
                <span className="col-span-2">{clientVersion?.hash}</span>
              </div>
              <div className="grid grid-cols-3">
                <span className="col-span-1">Branch: </span>
                <span className="col-span-2">{clientVersion?.branch}</span>
              </div>
              <div className="grid grid-cols-3">
                <span className="col-span-1">Build Time: </span>
                <span className="col-span-2">{clientVersion?.time}</span>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
